import React from 'react';
import ReactDOM from 'react-dom/client';
import $ from 'jquery';
import App from './App';
import './utils/i18n/i18n'
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './utils/msal/authConfig';

window.$ = $;
window.jQuery = $;

/**
 * Initialize a PublicClientApplication instance which is provided to the MsalProvider component
 * We recommend initializing this outside of your root component to ensure it is not re-initialized on re-renders
 */
const msalInstance = new PublicClientApplication(msalConfig);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <MsalProvider instance={msalInstance}>
        <App />
    </MsalProvider>
);
